<template>
  <div
    class="bg fill-height"
  >
    <v-container class="fill-height">
      <v-row
        align="center"
        justify="center"
        class="fill-height"
      >
        <v-col>
          <v-img
            :src="require('@/assets/logo/grafismo-logo-mappa.png')"
            contain
            max-width="500px"
          >
          </v-img>
        </v-col>
        <v-col
          class="text-center"
        >
          <p class="display-4 font-weight-regular">404</p>
          <p class="display-1 font-weight-regular">Desculpe!</p>
          <p class="display-1 font-weight-regular">Essa página parece não existir.</p>
          <v-col
            v-if="isLoggedIn"
            cols="12"
          >
            <span class="body-2 font-weight-regular">Talvez volte para a </span>
            <span class="body-2 font-weight-regular"><router-link to="/app">lista de processamentos</router-link>? </span>
            <span class="body-2 font-weight-regular">Ou que tal um <router-link to="/app/project">novo projeto</router-link>?</span>
          </v-col>
          <v-col
            v-else
            cols="12"
          >
            <span class="body-2 font-weight-regular">Talvez volte para o </span>
            <span class="body-2 font-weight-regular"><router-link to="/login">Login</router-link>? </span>
            <span class="body-2 font-weight-regular">Ou voltar para a <router-link to="/">página inicial</router-link>?</span>
          </v-col>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
        >

        </v-col>
        <v-col
          cols="12"
        >

        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: "NotFound",
    computed: {
      isLoggedIn() {
        return Boolean(this.$apiAuth.getAuthToken(false, false))
      },
    },
  }
</script>

<style scoped lang="scss">
  .bg {
    background: url("../../assets/general/bg-neutral.jpg");
    background-size: cover;
  }
</style>
